export default __webpack_public_path__ + "static/logos-hp-458eab431aab652ca5cf395fa8f65c3e.png";